/* BS · Consent bar (WebSolve). Records consent only through Shopify's Customer Privacy API.
   Docs: shopify.dev/docs/api/customer-privacy (read 23 Oct 2026). No imports from Horizon. */
(() => {
  if (customElements.get('bs-consent-bar')) return;

  class BsConsentBar extends HTMLElement {
    connectedCallback() {
      this.prefs = this.querySelector('.bs-consent__prefs');
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-bs-consent]');
        if (btn) this.act(btn.dataset.bsConsent, btn);
      });
      this.loadApi();
    }

    loadApi() {
      const ready = () => {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp) return;
        this.cp = cp;
        // Show only when Shopify says this visitor needs a banner (region + no choice yet).
        // ?bs_consent=test forces the bar on for checking.
        const forced = new URLSearchParams(location.search).get('bs_consent') === 'test';
        // shouldShowBanner() can stay true after a choice, so also check the recorded choice.
        const c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : {};
        const decided = ['analytics', 'marketing', 'preferences'].some((k) => c && (c[k] === 'yes' || c[k] === 'no'));
        const want = forced || (!decided && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner());
        if (!want) return;
        this.hidden = false; // Shopify's banner is hidden by CSS in the snippet
      };
      if (window.Shopify && window.Shopify.customerPrivacy) return ready();
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (err) => {
        if (!err) ready();
      });
    }

    act(kind, btn) {
      if (kind === 'settings') {
        const open = this.prefs.hidden;
        this.prefs.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        return;
      }
      let consent;
      if (kind === 'accept') consent = { analytics: true, marketing: true, preferences: true };
      else if (kind === 'decline') consent = { analytics: false, marketing: false, preferences: false };
      else if (kind === 'save') {
        consent = {};
        ['analytics', 'marketing', 'preferences'].forEach((k) => {
          const box = this.prefs.querySelector(`input[name="${k}"]`);
          consent[k] = !!(box && box.checked);
        });
      } else return;
      if (!this.cp) return;
      // Recorded only on a visitor click, never automatically (Shopify's rule).
      this.cp.setTrackingConsent(consent, () => {});
      this.hidden = true;
    }
  }

  customElements.define('bs-consent-bar', BsConsentBar);
})();
